import styled, { css } from 'styled-components';

export const ToC = styled.div`
  text-align: left !important;
  width: 100%;
  margin: 20px 0 37px;
  padding: 40px 40px 28px;
  background: var(--titan-blue-1);
  border: 1px solid var(--grey-3);

  h6 {
    font-weight: var(--font-weight-900);
    font-size: var(--font-size-25);
    line-height: var(--line-height-120);
    letter-spacing: var(--letter-spacing--0-02);
    color: var(--dark);
    margin-bottom: 24px !important;
  }

  ol {
    margin: 0;
    padding-inline-start: 25px;
    list-style-type: decimal !important;
    counter-reset: item;
  }

  & > ol {
    padding-inline-start: 0;
  }

  li {
    font-weight: var(--font-weight-500);
    font-size: var(--font-size-20);
    line-height: var(--line-height-150);
    color: var(--dark);
    display: block;

    &:before {
      content: counters(item, '.') '. ';
      counter-increment: item;
      margin: 6px 0;
      margin-right: 5px;
    }
  }

  h3 {
    margin: 6px 0 !important;
    display: inline-block;
    letter-spacing: normal;

    a {
      font-weight: var(--font-weight-500);
      font-size: var(--font-size-20);
      line-height: var(--line-height-150);
      color: var(--titan-blue-3);
    }
  }

  @media (max-width: 767px) {
    padding: 20px 20px 8px;

    h6 {
      font-size: var(--font-size-22);
      margin-bottom: 15px !important;
    }

    ol {
      padding-inline-start: 15px;
    }

    li {
      font-size: var(--font-size-16);
      margin: 6px 0px;
    }
    h3 {
      display: contents;
      a {
        font-size: var(--font-size-16);
      }
    }
    p {
      a {
        font-size: var(--font-size-16);
      }
    }
  }
`;

export const styledOL = styled.ol`
  margin-top: 20px;
`;

export const StyledLi = styled.li`
  display: list-item;
  text-align: -webkit-match-parent;
`;

export const TitleCSS = css`
  font-size: var(--font-size-22);
  h1 {
    font-size: var(--font-size-44);
  }
  h2 {
    font-size: var(--font-size-35);
  }
  h3 {
    font-size: var(--font-size-25);
  }
`;

export const H1 = styled.h1`
  ${TitleCSS}
`;
export const H2 = styled.h2`
  ${TitleCSS}
`;
export const H3 = styled.h3`
  ${TitleCSS}
`;
export const H4 = styled.h4`
  ${TitleCSS}
`;
export const H5 = styled.h5`
  ${TitleCSS}
`;
export const H6 = styled.h6`
  ${TitleCSS}
`;
